import { render, staticRenderFns } from "./importDepartment.vue?vue&type=template&id=09dc7dba&scoped=true"
import script from "./importDepartment.vue?vue&type=script&lang=js"
export * from "./importDepartment.vue?vue&type=script&lang=js"
import style0 from "./importDepartment.vue?vue&type=style&index=0&id=09dc7dba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dc7dba",
  null
  
)

export default component.exports